module.exports = __webpack_public_path__ + "static/assets/d13314f2c3776e360f574aa2add3903f.gif";